import { useEffect } from 'react'
import { useWeb3Context } from './hooks'
import './App.css';
import Airdrop from "./pages/Airdrop";

const App = () => {
  const { hasCachedProvider, connect } = useWeb3Context()
  useEffect(() => {
    if (hasCachedProvider()) {
      connect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <Airdrop />;
}

export default App;
